// eslint-disable-next-line @typescript-eslint/no-namespace
export var Backend;
(function (_Backend) {
  var isBackendError = _Backend.isBackendError = function (error) {
    return error.retcode !== undefined;
  };
  var RetCode = /*#__PURE__*/function (RetCode) {
    RetCode[RetCode["SUCCESS"] = 0] = "SUCCESS";
    RetCode[RetCode["XSRF_ERROR"] = 11007] = "XSRF_ERROR";
    RetCode[RetCode["DENY_ACCESS"] = 12607] = "DENY_ACCESS";
    RetCode[RetCode["FILE_NOT_EXIST"] = 11510] = "FILE_NOT_EXIST";
    RetCode[RetCode["NOT_FINISH"] = 12973] = "NOT_FINISH";
    RetCode[RetCode["IMPORT_FAILED"] = 12974] = "IMPORT_FAILED";
    RetCode[RetCode["NO_PERMISSION"] = 320112] = "NO_PERMISSION";
    RetCode[RetCode["PREVIEW_FAIL"] = 320114] = "PREVIEW_FAIL";
    return RetCode;
  }({}); // 接口回来的预览失败，请重试或下载到本地查看, 具体失败原因需要找后台看, 这里做一个降级体验
  _Backend.RetCode = RetCode;
  var FileAuditStatus = /*#__PURE__*/function (FileAuditStatus) {
    FileAuditStatus[FileAuditStatus["Regular"] = 0] = "Regular";
    FileAuditStatus[FileAuditStatus["Illegal"] = 1] = "Illegal";
    FileAuditStatus[FileAuditStatus["Pass"] = 2] = "Pass";
    FileAuditStatus[FileAuditStatus["Auditing"] = 3] = "Auditing";
    FileAuditStatus[FileAuditStatus["ShouldRetry"] = 4] = "ShouldRetry";
    FileAuditStatus[FileAuditStatus["Defraud"] = 5] = "Defraud";
    FileAuditStatus[FileAuditStatus["Status_Unknown"] = 6] = "Status_Unknown";
    FileAuditStatus[FileAuditStatus["Exemption"] = 7] = "Exemption";
    FileAuditStatus[FileAuditStatus["Illegal_Two"] = 72] = "Illegal_Two";
    FileAuditStatus[FileAuditStatus["Illegal_One"] = 98] = "Illegal_One";
    return FileAuditStatus;
  }({}); // 一级封禁, 所有人不可见不可申诉
  _Backend.FileAuditStatus = FileAuditStatus;
  /**
   * 查询 Drive 文件：fileId = drive文件id
   * 查询 附件：fileId=宿主文档id，obj_key=附件id
   */
  /**
   * 当带 objKey 的时候, fileId 得是附件所在文档的 padId, 也就是宿主的 id
   */
  var AccessType = /*#__PURE__*/function (AccessType) {
    AccessType[AccessType["PREVIEW"] = 1] = "PREVIEW";
    AccessType[AccessType["DOWNLOAD"] = 0] = "DOWNLOAD";
    return AccessType;
  }({});
  _Backend.AccessType = AccessType;
  var TranscodeStatus = /*#__PURE__*/function (TranscodeStatus) {
    TranscodeStatus[TranscodeStatus["Submitted"] = 0] = "Submitted";
    TranscodeStatus[TranscodeStatus["Running"] = 1] = "Running";
    TranscodeStatus[TranscodeStatus["Success"] = 2] = "Success";
    TranscodeStatus[TranscodeStatus["Failed"] = 3] = "Failed";
    return TranscodeStatus;
  }({});
  _Backend.TranscodeStatus = TranscodeStatus;
  var TranscodeType = /*#__PURE__*/function (TranscodeType) {
    TranscodeType[TranscodeType["MP3Original"] = 0] = "MP3Original";
    TranscodeType[TranscodeType["MP4Original"] = 1] = "MP4Original";
    TranscodeType[TranscodeType["MP4FLU"] = 2] = "MP4FLU";
    TranscodeType[TranscodeType["MP4HD"] = 3] = "MP4HD";
    TranscodeType[TranscodeType["MP4FHD"] = 4] = "MP4FHD";
    return TranscodeType;
  }({}); // 1080p分辨率转码
  _Backend.TranscodeType = TranscodeType;
})(Backend || (Backend = {}));
//# sourceMappingURL=backend.js.map